/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const BoxBorderTextModule = (props) => {

    return (
        <div className="boxBorder">
            <svg version="1.1" id="boxBorderTextModule" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 807.8 246.1" enableBackground="new 0 0 807.8 246.1" xmlSpace="preserve" preserveAspectRatio="none">
                <path className="boxBorder__path" id={props.id} fill="none" stroke="#EAEDF2" strokeWidth="5" strokeMiterlimit="10" d="M404.1,243.3h392.6c4.7,0,8.5-3.8,8.5-8.5v-224
                    c0-4.7-3.8-8.5-8.5-8.5H11.2c-4.7,0-8.5,3.8-8.5,8.5v224c0,4.7,3.8,8.5,8.5,8.5H404.1z"/>
            </svg>
        </div>
    );
}

export default BoxBorderTextModule;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/BoxBorderTextModule.jsx